import { IonCardContent, IonCardHeader } from "@ionic/react";

interface Props {
  label: string;
  step: number;
  nbStep: number;
  children: any;
}

const Question: React.FC<Props> = ({ label, step, nbStep, children }) => {
  return (
    <div>
      <IonCardHeader>
        <p className="black-text bold center-align-text">
          {`${step + 1}/${nbStep + 1} ${label}`}
        </p>
      </IonCardHeader>
      <IonCardContent>{children}</IonCardContent>
    </div>
  );
};

export default Question;
